<!-- eslint-disable -->
<template lang="pug">
    .box
        .box-body
            .opponents_title
                | {{ $i18n.t('battle.battle_opponentsList') }}
            .opponents__block
                .opponents__list
                    .opponents__players-not-found(v-if="!isLoading && opponents.length === 0")
                        | {{ $i18n.t('battle.battle_playersNotFound') }}
                    template(v-for="opponent in opponents")
                        .opponent(:class="{'opponent_blocked': opponent.isInvitationBlocked}")
                            .opponent__avatar
                                img(:src="opponent.avatar")
                            .opponent__full-name
                                | {{ opponent.fullName + ' (' + opponent.city + ') ' }}
                                .opponent__online
                    .opponents-loader(v-if='isLoading')
                        cs-loader
            .opponents__buttons-container
                cs-button.opponents__button(v-if="!isLoading && showBattleButton" color="blue" @click="findOpponent" :disabled="isLoading")
                    | {{ $i18n.t('battle.battle_start') }}
                template(v-else) {{ $i18n.t('battle.battle_no_opponents_try_later') }}
</template>

<script>
    /*eslint-disable*/
    import BattleApi from '../../../api/battle';
    import { mapState } from 'vuex';
    import _ from 'lodash';

    export default {
        props: {
            battleId: {
                type: Number,
                default: 0,
            },
        },
        data() {
            return {
                opponents: [],
                showBattleButton: false,
                isLoading: true,
            };
        },
        computed: {
            ...mapState({
                course: state => state.trainer.course,
            }),
        },
        mounted() {
            if (this.battleId < 1) {
                this.$router.push({ name: 'dashboard' });
            }
            this.fetchData();
        },
        methods: {
            fetchData() {
                this.isLoading = true;
                BattleApi.getListOpponentsForBattle({ course_type: _.kebabCase(this.course) })
                    .then(data => {
                        this.opponents = data.opponents;
                        this.showBattleButton = data.showBattleButton;
                        this.isLoading = false;
                    })
                    .catch(error => {
                        this.$toasted.error(this.$root.$t('errors.error_has_occurred'));
                        this.isLoading = false;
                    });
            },
            findOpponent() {
                BattleApi.getListOpponentsForBattle({ course_type: _.kebabCase(this.course) }).then(data => {
                    if (data.opponents.length === 0) {
                        this.$toasted.error(this.$i18n.t('battle.battle_invitation_ignored'));
                        this.fetchData();
                        return;
                    }
                    this.$router.push({ name: 'battles:opponent', params: { battleId: this.battleId } });
                });
            },
        },
    };
</script>

<style lang="scss" scoped>
    .box {
        box-sizing: border-box;
        width: 100%;
        background: #ffffff;
        display: flex;
        justify-content: center;
        align-items: flex-start;
        border-radius: 0;
        box-shadow: none;
        padding: 0;
        @include media($sm) {
            padding: 30px;
            box-shadow: 0 0 54px #51a552;
            border-radius: 40px;
        }
    }

    .box-body {
        box-sizing: border-box;
        width: 100%;
        height: auto;
        padding: 30px 20px;
        background-color: $hsl-color-gray-98_4;
        border-radius: $border-radius-20;
        @include media($sm) {
            height: 467px;
            width: 576px;
            padding: 30px;
        }
        @include media($md) {
            width: 557px;
        }
        @include media($lg) {
            width: 600px;
        }
    }

    .opponents_title {
        font-size: 22px;
        font-weight: 500;
        text-align: center;
        @include stack-space($space-base);
    }

    .opponents__search {
        @include stack-space($space-base);
    }

    .opponents__block {
        height: 220px;
        border: 1px solid $hsl-color-gray-74;
        border-radius: $border-radius-5;
        background-color: $x-color-white;
        padding: 5px;
        @include stack-space($space-large);
    }

    .opponents__list {
        height: 100%;
        overflow-y: scroll;

        &::-webkit-scrollbar {
            width: 6px;
        }

        &::-webkit-scrollbar-thumb {
            border-radius: 10px;
            background-color: #c4c4c4;
        }

        &::-webkit-scrollbar-track {
            border-radius: 10px;
        }
    }

    .opponents__players-not-found {
        margin: 10px;
        color: $hsl-color-gray-51;
        font-weight: 300;
    }

    .opponent {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding: 10px 15px 10px 0;
        border-radius: $border-radius-5;
        cursor: default;
    }

    .opponent_blocked {
        opacity: 0.4;
        background-color: $hsl-color-gray-88;
    }

    .opponent__avatar {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        margin: 0 10px;
        overflow: hidden;
        background-color: $hsl-color-gray-97;

        img {
            height: 100%;
        }
    }

    .opponent__full-name {
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 19px;
        color: #333333;
        margin-right: 10px;
        max-width: 68%;
        @include media($sm) {
            max-width: 85%;
        }
        position: relative;
    }

    .opponent__online {
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background-color: $hsl-color-green-58;
        position: absolute;
        right: -18px;
        top: 6px;
    }

    .opponents__buttons-container {
        display: flex;
        justify-content: center;
    }
</style>
